import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";


import Countries from "../ext/geo-countries/countries_geo.json"
import { useEffect } from "react";
import { ProgressMarker, ProgressMarker2, progress } from "../input/progress_scores";
const postal = require('postal');

function computeStyle(progress?: ProgressMarker | ProgressMarker2) {

  function _progress() {
    if (!progress) {
      return
    }

    if ( typeof progress === "string") {
      return progress as ProgressMarker
    }

    if (progress.type === "ProgressMarker2") {
      return progress.score
    }
  }

  function defaultFillColor() { return "grey" }

  function computeColor() {
    switch (_progress()) {
      case "low":
        return "purple";
      case "med":
        return "blue";
      case "high":
        return "green";
      default:
        return defaultFillColor()
    }
  }

  return {
    weight: 2,
    opacity: 1,
    color: "black",
    fillOpacity: 0.7,
    fillColor: computeColor(),
  };

}

function regionStyle(feature: any) {
  const country_code = feature.properties.ISO_A3

  return computeStyle(progress.get(country_code))
}

const geoData: any = {
  type: "FeatureCollection",
  features: Countries.features
}

function Legend() {

  return (
    <div className="legend">
      Adoption
      <ul className="legend-list">
        <li className="legend-item">
          <div className="color-box" style={{ backgroundColor: "green" }}></div>
          leading
        </li>
        <li className="legend-item">
          <div className="color-box" style={{ backgroundColor: "blue" }}></div>
          high
        </li>
        <li className="legend-item">
          <div className="color-box" style={{ backgroundColor: "purple" }}></div>
          starting
        </li>
        <li className="legend-item">
          <div className="color-box" style={{ backgroundColor: "grey" }}></div>
          unknown
        </li>
      </ul>
    </div>
  )
}

function WorldMap() {

  function onEachFeature(feature: any, layer: any) {
    layer.on({
      click: (e: any) => {
        postal.publish({
          channel: "ui",
          topic: "updateInfoPanel",
          data: { type:'feature', feature: feature } 
        })
      },
    });
  }

  return (
    <div className="world-map">
      <MapContainer
        center={[0, 0]}
    zoom={2}
    style={{ height: "100%", width: "100%" }}
      >
        {/* Tile layer for the map */}
      <GeoJSON data={geoData} style={regionStyle}
    onEachFeature={onEachFeature}
      />

      </MapContainer>
      <Legend />
    </div>
  );
}

export { WorldMap }